var DateWithUTC = /** @class */ (function () {
    function DateWithUTC(ts, utc) {
        this.date = new Date(ts);
        this.utc = utc;
    }
    DateWithUTC.prototype.getFullYear = function () {
        return this.utc ? this.date.getUTCFullYear() : this.date.getFullYear();
    };
    DateWithUTC.prototype.getMonth = function () {
        return this.utc ? this.date.getUTCMonth() : this.date.getMonth();
    };
    DateWithUTC.prototype.getDate = function () {
        return this.utc ? this.date.getUTCDate() : this.date.getDate();
    };
    DateWithUTC.prototype.getHours = function () {
        return this.utc ? this.date.getUTCHours() : this.date.getHours();
    };
    DateWithUTC.prototype.getMinutes = function () {
        return this.utc ? this.date.getUTCMinutes() : this.date.getMinutes();
    };
    DateWithUTC.prototype.getSeconds = function () {
        return this.utc ? this.date.getUTCSeconds() : this.date.getSeconds();
    };
    DateWithUTC.prototype.setFullYear = function () {
        var _a, _b;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return this.utc ? (_a = this.date).setUTCFullYear.apply(_a, args) : (_b = this.date).setFullYear.apply(_b, args);
    };
    DateWithUTC.prototype.setMonth = function () {
        var _a, _b;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return this.utc ? (_a = this.date).setUTCMonth.apply(_a, args) : (_b = this.date).setMonth.apply(_b, args);
    };
    DateWithUTC.prototype.setDate = function () {
        var _a, _b;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return this.utc ? (_a = this.date).setUTCDate.apply(_a, args) : (_b = this.date).setDate.apply(_b, args);
    };
    DateWithUTC.prototype.setHours = function () {
        var _a, _b;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return this.utc ? (_a = this.date).setUTCHours.apply(_a, args) : (_b = this.date).setHours.apply(_b, args);
    };
    DateWithUTC.prototype.setMinutes = function () {
        var _a, _b;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return this.utc ? (_a = this.date).setUTCMinutes.apply(_a, args) : (_b = this.date).setMinutes.apply(_b, args);
    };
    DateWithUTC.prototype.setSeconds = function () {
        var _a, _b;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return this.utc ? (_a = this.date).setUTCSeconds.apply(_a, args) : (_b = this.date).setSeconds.apply(_b, args);
    };
    DateWithUTC.prototype.getTime = function () {
        return this.date.getTime();
    };
    return DateWithUTC;
}());
export { DateWithUTC };
